import classNames from "classnames";
import Image from "next/image";

interface ScreenshotEmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  section?: any;
  verbose?: boolean;
}

const ScreenshotEmptyState = ({ className, section, ...props }: ScreenshotEmptyStateProps) => {
  return (
    <div className={classNames("flex flex-1 flex-col items-center justify-center", className)} {...props}>
      <Image
        alt="Screenshot illustration"
        className=" w-44"
        height="176"
        src="/_public-pages-service/screenshot-illustration.svg"
        width="176"
      />
      <div className="text-vpGray-700">{section?.ScreenshotAppearsHere}</div>
    </div>
  );
};

export default ScreenshotEmptyState;
